/** Nome oficial exibido no site (config admin pode sobrescrever via siteName). */
export const DEFAULT_SITE_NAME = 'Knight Icarus Online';
